import { render } from "./TrendingSearchModal.vue?vue&type=template&id=6061e347&scoped=true&ts=true"
import script from "./TrendingSearchModal.vue?vue&type=script&lang=ts"
export * from "./TrendingSearchModal.vue?vue&type=script&lang=ts"

import "./TrendingSearchModal.vue?vue&type=style&index=0&id=6061e347&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061e347"]])

export default __exports__